import { useIsMutating } from '@tanstack/react-query'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Button } from 'reactstrap'
import exportApi from '../api/export/hooks'
import { MODAL_TYPES } from '../common/constants'
import { showModal } from '../store/modal'
import DateTime from './Common/DateTime'

const ExportSyncWidget = () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const { data, isFetching } = exportApi.GetSync.useQuery()
    const { lastSynchronization, synchronizationLeft } = data ?? {}

    const isSyncing = useIsMutating({ mutationKey: ['export', 'synchronize'] }) > 0
    const loading = isFetching || isSyncing

    const handleExportSyncModal = () => {
        dispatch(showModal({ modalType: MODAL_TYPES.EXPORT_SYNC_MODAL }))
    }

    const iconClassNames = classNames('mdi', 'mdi-refresh', {
        'mdi-spin': loading,
    })

    return (
        <div className="export-sync-controls hstack gap-3 ms-lg-auto">
            {synchronizationLeft && (
                <Button title={t('app.common.synchronize')} color="primary" outline className="btn btn-ghost-primary" onClick={handleExportSyncModal}>
                    <i className={iconClassNames} />
                    {synchronizationLeft}
                </Button>
            )}

            <div className="vr my-3" />
            {lastSynchronization && <DateTime className="fs-13" value={lastSynchronization} />}
            <div className="vr my-4" />
            {lastSynchronization && <DateTime className="fs-13 fw-light" value={lastSynchronization} timeOnly />}
        </div>
    )
}

export default ExportSyncWidget
